import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// #78: when the AUTOPLAY coordinator starts a video, mute it first. A manual play
// never mutes. The user's unmute/mute choice is remembered feed-wide at runtime.
export default class MuteOnAutoplay extends BaseOption {
  static userInterfaceComponent = {
    label: "Mute audio on autoplay",
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        {
          icon: "mdi:volume-off",
          tooltip: "Mute on autoplay",
          value: "Yes",
        },
        {
          icon: "mdi:volume-high",
          tooltip: "Keep sound on autoplay",
          value: "No",
        },
      ],
    },
  };

  static defaultValue = "Yes";

  static convertConfigValueToCompiledValue(configValue) {
    return configValue === "Yes";
  }
}
